import BaseRoute from "utils/base_route";
import ChildRenderer from "common_components/child_renderer";
import MatterEditorRoute from "routes/matter/matter_editor";
import MatterDocumentRoute from "routes/matter/matter_document";
import MatterDocumentDetail from "routes/matter/matter_document_detail";

import MatterList from "routes/matter/matter_list";

export default class MatterRoute extends BaseRoute {
  constructor(store) {
    super(":projectId/matter", store);
  }

  createChildRoutes() {
    return [
      new MatterList(this.store, "list"),
      new MatterEditorRoute(this.store, "new"),
      new MatterEditorRoute(this.store, ":matterId"),
      new MatterDocumentRoute(this.store, ":matterId/document"),
      new MatterDocumentDetail(this.store, ":matterId/document/:documentId"),
    ];
  }

  getComponents(location, cb) {
    cb(null, ChildRenderer);
  }
}
